import AppConsts from './sissconst'
import Util from './utils'
class SignalRAspNetCoreHelper{
    initSignalR(){
        var encryptedAuthToken = Util.siss.utils.getCookieValue(AppConsts.authorization.encrptedAuthTokenName);

        Util.siss.signalr = {
            autoConnect: false,
            connect: undefined,
            hubs: undefined,
            qs: AppConsts.authorization.encrptedAuthTokenName + "=" + encodeURIComponent(encryptedAuthToken),
            url: ''
        };

        //Util.loadScript('/dist/signalr.min.js');
        //Util.loadScript('/abp.signalr-client.js');
    }
    initSignalRBack(callback){
        var encryptedAuthToken = Util.siss.utils.getCookieValue(AppConsts.authorization.encrptedAuthTokenName);

        Util.siss.signalr = {
            autoConnect: true,
            connect: undefined,
            hubs: undefined,
            qs: AppConsts.authorization.encrptedAuthTokenName + "=" + encodeURIComponent(encryptedAuthToken),
            url: ''
        };

        //Util.loadScript('/dist/signalr.min.js');
        //Util.loadScriptBack('/abp.signalr-client.js',callback);
    }
}
export default new SignalRAspNetCoreHelper();